"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MultiSelectComponent = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _autosizeInput = _interopRequireDefault(require("autosize-input"));

var _classnames = _interopRequireDefault(require("classnames"));

var _DropDown = _interopRequireWildcard(require("../DropDown"));

var _Tags = _interopRequireWildcard(require("../Tags"));

var _Spinner = _interopRequireDefault(require("../Spinner"));

var _Menu = _interopRequireDefault(require("../Menu"));

var _Select = require("../Select");

var _cross = _interopRequireDefault(require("../icons/cross.svg"));

var _config = require("../config/config");

var _withNamedError = _interopRequireDefault(require("../withNamedError"));

var _prepareInputName = _interopRequireDefault(require("../_utils/prepareInputName"));

var _keyCodes = require("../_utils/keyCodes");

require("./multiSelect.sass");

var _ref2 = _react.default.createElement(_Spinner.default, null);

var MultiSelectComponent =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(MultiSelectComponent, _PureComponent);

  function MultiSelectComponent() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, MultiSelectComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(MultiSelectComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "align", _DropDown.ALIGN_LEFT | _DropDown.ALIGN_BOTTOM | _DropDown.ALIGN_WIDTH);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "inputRef", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "dropDownRef", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "controlled", _this.props.hasOwnProperty('values'));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      input: '',
      values: _this.controlled ? null : _this.props.defaultValues
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleInputRef", function (input) {
      _this.inputRef = input;

      if (input) {
        _this.fixSize = (0, _autosizeInput.default)(input);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleDropDownRef", function (input) {
      return _this.dropDownRef = input;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleElementAdd", function (e, element) {
      var elements = !element.props.selectAll ? [element] : _react.default.Children.toArray(_this.props.children).filter(function (child) {
        return child && child.props && !child.disabled && !child.props.selectAll;
      });
      var value = elements.map(function (el) {
        return el.props.hasOwnProperty('value') ? el.props.value : el.props.label;
      });

      _this.add(e, value);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "add", function (e, values) {
      var stateValues = _this.getValues();

      values = Array.isArray(values) ? values : [values];
      values.forEach(function (value) {
        return _this.props.onAdd && _this.props.onAdd(e, value);
      });

      if (values.length > _this.props.maxSelectOptions) {
        return;
      }

      if (!_this.controlled) {
        values = values.filter(function (value) {
          return !stateValues.some(function (element) {
            return element.value === value;
          });
        });

        _this.onType(e, '');

        _this.setState({
          values: values.length ? stateValues.concat(values.map(function (value) {
            return {
              value: value,
              label: _this.getLabelByValue(value)
            };
          })) : stateValues
        }, function () {
          if (_this.inputRef) {
            _this.fixSize();

            _this.inputRef.focus();
          }
        });

        e.preventDefault();
        e.stopPropagation();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "remove", function (e, value) {
      e.stopPropagation();
      _this.props.onRemove && _this.props.onRemove(e, value);

      if (!_this.controlled) {
        _this.setState((0, _objectSpread2.default)({}, _this.state, {
          values: _this.getValues().filter(function (element) {
            return element.value !== value;
          })
        }));
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "isSelected", function (value) {
      return _this.getValues().some(function (currentElement) {
        return currentElement.value === value;
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onDropDownShow", function () {
      _this.setState({
        focus: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onDropDownHide", function (e) {
      _this.onType(e, '');

      _this.setState({
        focus: false
      });

      _this.inputRef && _this.inputRef.blur();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onKeyDown", function (e) {
      var _this$props = _this.props,
          onKeyDown = _this$props.onKeyDown,
          children = _this$props.children,
          isCreatable = _this$props.isCreatable,
          maxSelectOptions = _this$props.maxSelectOptions;

      var values = _this.getValues();

      var value = e.target.value.trim();
      var child;
      onKeyDown && onKeyDown(e);

      switch (e.keyCode) {
        case _keyCodes.KEY_CODE_BACKSPACE:
          if (_this.state.input === '' && values.length > 0) {
            e.preventDefault();

            _this.remove(e, values.slice(-1).pop().value);
          }

          break;

        case _keyCodes.KEY_CODE_SUBMIT:
          e.stopPropagation();
          child = _react.default.Children.toArray(children).filter(function (element) {
            return element && element.props && !element.disabled;
          }).find(function (element) {
            var label = element.props.label;
            return label && label.trim().toLowerCase() === value.toLowerCase();
          });

          if (maxSelectOptions && values.length >= maxSelectOptions) {
            return;
          }

          if (child) {
            _this.handleElementAdd(e, child);
          } else if (isCreatable && value) {
            _this.add(e, value);
          }

          break;

        default:
          break;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onFocus", function (e) {
      _this.props.onFocus && _this.props.onFocus(e);
      _this.dropDownRef && _this.dropDownRef.show();

      _this.setState({
        focus: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onBlur", function (e) {
      _this.props.onBlur && _this.props.onBlur(e);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onChange", function (e) {
      _this.props.onChange && _this.props.onChange(e);

      _this.onType(e, e.target.value);

      _this.dropDownRef && _this.dropDownRef.setPosition();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onType", function (e, text) {
      _this.props.onType && _this.props.onType(e, text);

      _this.setState({
        input: text
      });
    });
    return _this;
  }

  (0, _createClass2.default)(MultiSelectComponent, [{
    key: "getLabelByValue",
    value: function getLabelByValue(value) {
      var children = this.props.children;

      var item = _react.default.Children.toArray(children).find(function (_ref) {
        var props = _ref.props;
        return props && props.hasOwnProperty('label') && props.value === value;
      });

      if (item && item.props.label) {
        return item.props.label;
      }

      return value;
    }
  }, {
    key: "getValues",
    value: function getValues() {
      if (this.controlled) {
        return this.props.values || [];
      }

      return this.state.values || [];
    }
  }, {
    key: "getMultiName",
    value: function getMultiName(name) {
      name = (0, _prepareInputName.default)(name);
      return name.substr(-2) === '[]' ? name : "".concat(name, "[]");
    }
  }, {
    key: "inputFilter",
    value: function inputFilter() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var inputValue = this.state.input.trim().toLowerCase();
      var compareValue = value.trim().toLowerCase();
      return compareValue.includes(inputValue);
    }
  }, {
    key: "getChildrenArray",
    value: function getChildrenArray() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          maxOptionsToShow = _this$props2.maxOptionsToShow,
          isCreatable = _this$props2.isCreatable,
          maxSelectOptions = _this$props2.maxSelectOptions,
          hasSelectAll = _this$props2.hasSelectAll,
          maxSelectOptionsLabel = _this$props2.maxSelectOptionsLabel,
          pressEnterToCreateOptionLabel = _this$props2.pressEnterToCreateOptionLabel,
          emptyOptionLabel = _this$props2.emptyOptionLabel,
          showTypeForMore = _this$props2.showTypeForMore;
      var values = this.getValues();

      var items = _react.default.Children.toArray(children).filter(function (element) {
        return element && element.props;
      }).filter(function (element) {
        var value = element.props.hasOwnProperty('value') ? element.props.value : element.props.label;
        return !_this2.isSelected(value) && _this2.inputFilter(element.props.label);
      });

      if (maxSelectOptions && values.length >= maxSelectOptions) {
        return [_react.default.createElement(_Select.Option, {
          key: "",
          disabled: true,
          label: maxSelectOptionsLabel || (0, _config.__)('Maximum number of values selected')
        })];
      }

      if (isCreatable && !items.some(function (element) {
        return !element.props.disabled;
      })) {
        return [_react.default.createElement(_Select.Option, {
          key: "",
          disabled: true,
          label: pressEnterToCreateOptionLabel || (0, _config.__)('Press Enter to create')
        })];
      }

      if (items.length === 0 && !showTypeForMore) {
        return [_react.default.createElement(_Select.Option, {
          key: "",
          disabled: true,
          label: emptyOptionLabel || (0, _config.__)('Empty')
        })];
      }

      if (items.length > maxOptionsToShow || showTypeForMore) {
        return (0, _toConsumableArray2.default)(items.slice(0, maxOptionsToShow)).concat([_react.default.createElement(_Select.Option, {
          key: "",
          disabled: true,
          label: (0, _config.__)('... type for more elements')
        }), hasSelectAll ? _react.default.createElement(_Select.Option, {
          key: "",
          label: (0, _config.__)('Select All'),
          selectAll: true
        }) : null]).filter(function (value) {
          return value !== null;
        });
      }

      if (hasSelectAll && items.length > 1) {
        return (0, _toConsumableArray2.default)(items).concat([_react.default.createElement(_Select.Option, {
          key: "",
          label: (0, _config.__)('Select All'),
          selectAll: true
        })]);
      }

      return items;
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this3 = this;

      if (this.props.isLoading) {
        return _ref2;
      }

      return this.getChildrenArray().map(function (element) {
        return _react.default.cloneElement(element, {
          onClick: function onClick(e) {
            _this3.handleElementAdd(e, element);

            setTimeout(function () {
              return _this3.inputRef && _this3.inputRef.focus();
            }, 10);
          }
        });
      });
    }
  }, {
    key: "formatError",
    value: function formatError(error) {
      switch ((0, _typeof2.default)(error)) {
        case 'string':
          return error;

        case 'object':
          return error[Object.keys(error)[0]];

        default:
          return 'New error format ' + JSON.stringify(error);
      }
    }
  }, {
    key: "isDirty",
    value: function isDirty() {
      var values = this.state.values;
      return values && values.length > 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props3 = this.props,
          name = _this$props3.name,
          error = _this$props3.error,
          label = _this$props3.label;
      var focus = this.state.focus;
      var values = this.getValues();

      var input = _react.default.createElement("div", {
        className: (0, _classnames.default)('input multiSelect', {
          'input--label': label,
          'input--dirty': this.isDirty(),
          'input--focus': focus
        })
      }, label && _react.default.createElement("span", {
        className: "form-field-label"
      }, label), _react.default.createElement(_Tags.default, {
        className: "input-field"
      }, values.map(function (_ref3, key) {
        var value = _ref3.value,
            label = _ref3.label;
        return _react.default.createElement(_Tags.Tag, {
          onIconClick: function onIconClick(e) {
            return _this4.remove(e, value);
          },
          key: key,
          value: value,
          label: label,
          Icon: _cross.default
        });
      }), _react.default.createElement("input", {
        key: "input",
        className: "multiSelect-input",
        ref: this.handleInputRef,
        onChange: this.onChange,
        onKeyDown: this.onKeyDown,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        value: this.state.input
      })), error && _react.default.createElement("span", {
        className: "form-field-error"
      }, this.formatError(error)), name && values.map(function (_ref4, key) {
        var value = _ref4.value;
        return _react.default.createElement("input", {
          key: key,
          type: "hidden",
          value: value,
          name: _this4.getMultiName(name)
        });
      }));

      return _react.default.createElement(_DropDown.default, {
        className: "form-field",
        ref: this.handleDropDownRef,
        trigger: input,
        align: this.align,
        onShow: this.onDropDownShow,
        onHide: this.onDropDownHide
      }, _react.default.createElement(_Menu.default, {
        scope: "input"
      }, this.renderItems()));
    }
  }]);
  return MultiSelectComponent;
}(_react.PureComponent);

exports.MultiSelectComponent = MultiSelectComponent;
(0, _defineProperty2.default)(MultiSelectComponent, "defaultProps", {
  defaultValues: [],
  maxOptionsToShow: 10
});
MultiSelectComponent.propTypes = process.env.NODE_ENV !== "production" ? {
  name: _propTypes.default.string,
  error: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),
  label: _propTypes.default.string,
  defaultValues: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool])
  })),
  values: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool])
  })),
  maxOptionsToShow: _propTypes.default.number,
  isCreatable: _propTypes.default.bool,
  maxSelectOptions: _propTypes.default.number,
  maxSelectOptionsLabel: _propTypes.default.string,
  pressEnterToCreateOptionLabel: _propTypes.default.string,
  emptyOptionLabel: _propTypes.default.string,
  typeForMoreElementsOptionLabel: _propTypes.default.string,
  selectAllOptionLabel: _propTypes.default.string,
  isLoading: _propTypes.default.bool,
  hasSelectAll: _propTypes.default.bool,
  onAdd: _propTypes.default.func,
  onRemove: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onType: _propTypes.default.func,
  showTypeForMore: _propTypes.default.bool
} : {};

var _default = (0, _withNamedError.default)(MultiSelectComponent);

exports.default = _default;